import React from 'react'
import PropTypes from 'prop-types'

import { Icon, List, Popup } from 'semantic-ui-react'

const CardProperty = props => {
  if (props.href) {
    return (
      <List.Item onClick={props.onClick ? props.onClick : null}>
        <a href={props.href} download={props.download}>
          <Popup content={props.popUpContent} size="mini" trigger={<Icon color={props.color ? props.color : null} name={props.icon} />} />
          &nbsp;
          {props.children}
        </a>
      </List.Item>
    )
  }

  return (
    <span>
      <List.Item onClick={props.onClick ? props.onClick : null}>
        <Popup content={props.popUpContent} size="mini" trigger={<Icon color={props.color ? props.color : null} name={props.icon} />} />
        &nbsp;
        {props.children}
      </List.Item>
    </span>
  )
}

CardProperty.defaultProps = {
  download: false,
}

CardProperty.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  download: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  popUpContent: PropTypes.node.isRequired,
}

export default CardProperty
